import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    defaultEntity: {
        id: 0,
        codigo: "",
        nombre: "",
        idDireccion: 0,
        idUbigeo: 0,
        codigoUbigeo: "",
        ubigeo: "",
        direccion: "",
        idTipo: 84,
        tipo: "",
        idEstado: 2,
        estado: "Activo",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    entity: {
        id: 0,
        codigo: "",
        nombre: "",
        idDireccion: 0,
        idUbigeo: 0,
        codigoUbigeo: "",
        ubigeo: "",
        direccion: "",
        idTipo: 0,
        tipo: "",
        idEstado: 0,
        estado: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    listTipos: [{ id: 0, descripcion: "" }],
    listEstados: [{ id: 0, descripcion: "" }],
    validationActive: {
        codigo: false,
        nombre: false,
        idDireccion: false,
        idTipo: false,
        idEstado: false,
    },
    validationMessage: [],
}

export const filialSlice = createSlice({
    name: "filial",
    initialState,
    reducers: {
        setEntity: (state, action) => {
            state.entity = action.payload;
        },
        setData: (state, action) => {
            const { name, value } = action.payload;

            if (name.startsWith("id")) {
                state.entity[name] = parseInt(value);
            } else {
                state.entity[name] = value;
            }

            state.validationActive[name] = true;
        },
        setValidationMessage: (state, action) => {
            state.validationMessage = action.payload;
        },
        activeValidations: (state) => {
            Object.keys(state.validationActive).forEach(function (key) {
                state.validationActive[key] = true;
            })
        },
        setListTipos: (state, action) => {
            state.listTipos = action.payload;
        },
        setListEstados: (state, action) => {
            state.listEstados = action.payload;
        },
    },
});

export const { setEntity, setData, setValidationMessage, activeValidations
    , setListTipos, setListEstados } = filialSlice.actions;
export default filialSlice.reducer;